import { getVal } from 'oolib';

export const getActiveTciSpaceData = ({tplConfig, activeTciSpace}) => {
    return getVal(tplConfig, activeTciSpace.valuePath);
  };